// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var $$Set = require("bs-platform/lib/js/set.js");
var Char = require("bs-platform/lib/js/char.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var $$String = require("bs-platform/lib/js/string.js");
var Caml_string = require("bs-platform/lib/js/caml_string.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./app.css')));

var CharSet = $$Set.Make([Char.compare]);

function s(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("App");

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      var send = param[/* send */4];
      var state = param[/* state */2];
      var charsInWord = Curry._1(CharSet[/* of_list */25], $$Array.to_list($$Array.map((function (c) {
                      return Caml_string.get(c, 0);
                    }), state[/* word */0].split(""))));
      var wrongGuessesNo = Curry._1(CharSet[/* cardinal */18], Curry._2(CharSet[/* diff */8], state[/* guesses */1], charsInWord));
      var remaining = 6 - wrongGuessesNo | 0;
      var charOrUnderscore = function (c) {
        if (Curry._2(CharSet[/* exists */15], (function (e) {
                  return +(e === c);
                }), state[/* guesses */1])) {
          return c;
        } else {
          return /* "_" */95;
        }
      };
      var hiddenWord = $$String.map(charOrUnderscore, state[/* word */0]);
      var progress = remaining === 0 ? /* Lost */1 : (
          hiddenWord === state[/* word */0] ? /* Win */0 : /* Guessing */2
        );
      var tmp;
      switch (progress) {
        case 0 : 
            tmp = React.createElement("h3", undefined, "You WON!");
            break;
        case 1 : 
            tmp = React.createElement("h3", undefined, "You lost!");
            break;
        case 2 : 
            tmp = React.createElement("div", undefined, React.createElement("input", {
                      value: "",
                      onKeyDown: (function ($$event) {
                          var c = $$String.uppercase($$event.key);
                          if (c.length === 1) {
                            return Curry._1(send, /* Guess */[Caml_string.get(c, 0)]);
                          } else {
                            return /* () */0;
                          }
                        })
                    }), React.createElement("h3", undefined, "Guesses remaining: " + String(remaining)));
            break;
        
      }
      return React.createElement("div", {
                  className: "App"
                }, React.createElement("h2", undefined, "Hangman"), React.createElement("h1", undefined, hiddenWord), tmp, React.createElement("button", {
                      onClick: (function () {
                          return Curry._1(send, /* NewWord */0);
                        })
                    }, "New word"));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* word */"REASONML",
              /* guesses */CharSet[/* empty */0]
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (action) {
        return /* Update */Block.__(0, [/* record */[
                    /* word */state[/* word */0],
                    /* guesses */Curry._2(CharSet[/* add */3], action[0], state[/* guesses */1])
                  ]]);
      } else {
        return /* Update */Block.__(0, [/* record */[
                    /* word */"TWITCH",
                    /* guesses */CharSet[/* empty */0]
                  ]]);
      }
    });
  return newrecord;
}

exports.CharSet = CharSet;
exports.s = s;
exports.component = component;
exports.make = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/app.re
// module id = 28
// module chunks = 0